export interface ITaxAndCashEquityDetails {
  taxAndCashEquityDetailsId: number;
  fundSize: number;
  totalFinancingCost: number;
  monthToFlip: number;
  defaultPtoDate: Date;
}

export class TaxAndCashEquityDetails implements ITaxAndCashEquityDetails {
  taxAndCashEquityDetailsId: number;
  fundSize: number;
  totalFinancingCost: number;
  monthToFlip: number;
  defaultPtoDate: Date;
}
